import { type UserRole } from '@app/shared';
import { useSession } from '@/lib/auth-client';
import { ROUTES } from '@/constants/routes';

export type CurrentUser = {
  id: string;
  name: string;
  email: string;
  role: UserRole;
};

export function useCurrentUser() {
  const { data, isPending } = useSession();
  const sessionUser = data?.user as (typeof data extends null ? never : { role?: string }) | undefined;
  const role = (sessionUser?.role ?? null) as UserRole | null;
  const user: CurrentUser | null =
    data?.user && role
      ? {
          id: data.user.id,
          name: data.user.name,
          email: data.user.email,
          role,
        }
      : null;

  return {
    user,
    role,
    isAdmin: role === 'admin',
    isConsultant: role === 'consultant' || role === 'admin',
    isClient: role === 'client',
    isPending,
  };
}

export function defaultRouteFor(role: UserRole | null | undefined): string {
  if (role === 'admin') return ROUTES.admin();
  // Clients land on the assessments list, which is scoped to their company and
  // rendered read-only for them (see RequireRole / the assessments list).
  return ROUTES.assessments();
}
